interface SpotMapPreviewProps {
  name: string;
  locationName: string;
  district: string;
  /** Tailwind height utility for the map frame (defaults to a compact card preview). */
  heightClass?: string;
}

/**
 * A compact Google Maps preview for a tourist spot. Uses the keyless
 * `output=embed` endpoint so no API key is needed, plus a small "Open in Maps"
 * link for directions.
 */
export default function SpotMapPreview({
  name,
  locationName,
  district,
  heightClass = "h-32",
}: SpotMapPreviewProps) {
  const query = `${name}, ${locationName}, ${district}, Karnataka, India`;
  const embedSrc = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
  const directionsSrc = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

  return (
    <div className="relative overflow-hidden rounded-md border border-background-200 bg-background-100">
      <iframe
        title={`Map showing ${name} in ${district}`}
        src={embedSrc}
        className={`w-full ${heightClass} border-0`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      <a
        href={directionsSrc}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-md bg-background-50/95 px-2.5 py-1 text-[11px] font-semibold text-foreground-800 ring-1 ring-inset ring-background-300 backdrop-blur transition-colors hover:bg-background-50 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-external-link-line"></i> Open in Maps
      </a>
    </div>
  );
}